export default __webpack_public_path__ + "static/screenshot-dashboard@2x-39023b98aaf1c98e84f2243bb5d31990.png";